import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ChangeFormTaxResponse } from '../models/tax.model';

@Injectable({
	providedIn: 'root'
})
export class TaxService {
	private URL = environment.api + "api/erp/forms/tax";
	constructor(
		private http: HttpClient
	) { }

	/**
	 * Endpoint for get detail of the tax, by url https://app.dev.servicios.gt/api/erp/forms/tax/view?formId=3227
	 * @param formId the id of the form, get by a FormTaxResponse parameter id
	 * @returns an observer that in response.data has a result of type FormTaxResponse
	 */
	getViewTax(formId: number) {
		return this.http.get(this.URL + "/view", {
			params: {
				formId: formId
			}
		})
	}

	/**
	 * Endpoint for get detail of the tax, by url https://app.dev.servicios.gt/api/erp/forms/tax/history?formId=3227
	 * @param formId the id of the form, get by a FormTaxResponse parameter id
	 * @returns an observer that in response.data has a result of type HistoryTaxResponse
	 */
	getHistoryTax(formId: number) {
		return this.http.get(this.URL + "/history", {
			params: {
				formId: formId
			}
		})
	}

	/**
	 * Endpoint for get work the form tax, by url https://app.dev.servicios.gt/api/erp/forms/tax/work?formId=3221
	 * @param formId the id of the form, get by a FormTaxResponse parameter id
	 * @returns an observer that in response.data has a result of type FormTaxResponse
	 */
	getWorkFormTax(formId: number) {
		return this.http.get(this.URL + "/work", {
			params: {
				formId: formId
			}
		})
	}

	/**
	 * Service for the endpoint https://app.dev.servicios.gt/api/erp/forms/tax/top/providers?company=2875&month=1&year=2023
	 * @param company 
	 * @param month 
	 * @param year 
	 * @returns a list on the response.data of type TopProviderResponse
	 */
	getTopProviders(company: number, month: number, year: number) {
		return this.http.get(this.URL + "/top/providers", {
			params: {
				company: company,
				month: month,
				year: year
			}
		})
	}

	changeFormTax(formId: number, changed: ChangeFormTaxResponse) {
		return this.http.put(this.URL + "/change/state", changed, {
			params: {
				formId: formId
			}
		})
	}

	getStatusByType(type: number) {
		return this.http.get(this.URL + "/status", {
			params: {
				type: type
			}
		});
	}

	getFormsByMonthYearStatusAndType(
		year: number,
		month: number,
		status: number,
		type: number,
		isPartner = false
	) {
		return this.http.get(this.URL + (isPartner ? '/admin' : '') + `/${year}/${month}`, {
			params: {
				status: status,
				type: type
			}
		})
	}

	getFormsByYear(
		year: number,
	) {
		return this.http.get(this.URL + `/${year}`);
	}

	readyToPay(formId, request) {
		return this.http.post(this.URL + `/change/state?formId=${formId}`, request);
	}

	/**
	 * Service for the endpoint 
	 * @param file the pdf that will be uploaded
	 * @param formId the form of the pdf
	 * @param description the descrition of the form
	 * @returns 
	 */
	uploadFile(file, formId: number, description: string) {
		const formData = new FormData();
		formData.append('file', file);
		return this.http.post<any>(this.URL + `/upload?formId=${formId}`, formData, {
			params: {
				formId: formId,
				description: description
			}
		});
	}

	downloadForm(formId) {
		return this.http.get(this.URL + `/download?formId=${formId}`,{ responseType: 'blob' });
	}

}